<template>
    <footer>
        <v-container>
            <v-row>
                <v-col cols="12" md="4" class="pa-10">
                    <v-img
                            :src="require('../assets/img/logo-gr-white.svg')"
                            class="my-3"
                            contain
                            height="100"
                    />
                </v-col>

                <v-col cols="12" md="4" class="pa-10">
                    <h5>Enlaces</h5>
                    <p><a href="/aviso-legal-esp">Aviso legal</a></p>
                    <p><a href="/politica-cookies-esp">Política de cookies</a></p>
                </v-col>

                <v-col cols="12" md="4" class="pa-10">
                    <h5>Contacto</h5>
                    <p><v-icon color="#900A30">mdi-email-outline</v-icon> <a href="mailto:riola@gestoriariola.com">riola@gestoriariola.com</a></p>
                    <p><v-icon color="green">mdi-whatsapp</v-icon> <a href="tel:639086934">639086934</a></p>
                    <p><v-icon color="#454E4F">mdi-phone</v-icon> <a href="tel:977241707">977241707</a></p>
                    <address><v-icon color="red darken-4">mdi-google-maps</v-icon> <a href="https://goo.gl/maps/oB7HnhuBQtyNxuJt9" target="_blank">Rambla Nova 110, 2º 2ª · 43001 Tarragona</a></address>
                </v-col>

            </v-row>
            <v-row class="text-center">
                <v-col cols="12" class="pa-10">
                    <hr>
                    <p class="pt-10 text-center mb-1">Copyright © Gestoria Riola 2022 - {{ currentYear }} · Desde 1935 haciendo fácil lo difícil.</p>
                    <p class="text-center gr-credito">Diseñado por <a href="https://elestudioweb.com/" target="_blank" rel="noopener">El Estudio Web</a></p>
                </v-col>
            </v-row>
        </v-container>
    </footer>
</template>

<script>
    export default {
        name: "Footer",
        computed: {
            currentYear() {
                return new Date().getFullYear();
            }
        }
    }
</script>

<style scoped>
  .gr-credito {
    font-size: 0.85rem;
    opacity: 0.85;
  }
  .gr-credito a {
    color: inherit;
    text-decoration: underline;
    font-weight: 600;
  }
</style>
